<template>
  <div class="bProducts">
    <div class="bProducts__container container">
      <div class="bProducts__row row">
        <transition name="fade">
          <div class="bProductList col-12 col-md-4 col-lg-2"
          v-if="productListShown">
            <div class="bProductList__container">
              <ul class="bProductList__list row">
                <li class="bProductList__item col-12">
                  <a href="#" class="bProductList__a"
                  @click='start_creating_newProduct'>
                    <div class="bProductList__main">
                      新增產品
                    </div>
                  </a>
                </li>
                <li class="bProductList__item col-12"
                v-for="(item, index) in products"
                :key="index">
                  <a href="#" class="bProductList__a"
                  @click="start_editing(item.id)">
                    <div class="bProductList__img">
                      <img :src="item.images.main" alt="">
                    </div>
                    <div class="bProductList__main">
                      <span class="bProductList__title">
                        {{item.title}}
                      </span>
                      <span class="bProductList__id">
                        {{item.id}}
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </transition>
        <div class="bProductListFolder d-md-none">
          <button class="bProductListFolder__btn btn btn-secondary"
          @click.prevent='
          toggle_productList(!productListShown);
          toggle_productDetail(!productDetailShown);
          '>
            <span v-if="!productListShown">
              產品選單
            </span>
            <span v-if="!productDetailShown">
              產品細節
            </span>
          </button>
        </div>
        <transition name="fade">
          <form @submit.prevent="submit_form(currentProduct)"
          class="col-12 col-md-8 col-lg-10">
            <div class="bProductDetail"
            v-if="productDetailShown">
              <div class="bProductDetail__container">
                <div class="bProductDetail__header">
                  <div class="bProductDetail__row row">
                    <p class="bProductDetail__title col">
                      產品詳細資料
                    </p>
                    <div class="bProductDetail__funcBtns">
                      <button type="submit" class="btn btn-success mr-1"
                      v-if="!creatingNewProduct">
                        儲存變更
                      </button>
                      <button type="button" class="btn btn-danger"
                      v-if="!creatingNewProduct"
                      @click.prevent="delete_product(currentProduct)">
                        刪除產品
                      </button>
                      <button type="submit" class="btn btn-info"
                      v-if="creatingNewProduct">
                        新增產品
                      </button>
                    </div>
                  </div>
                </div>
                <div class="bProductDetail__body">
                  <div class="form-group">
                    <label for="product_id">產品ID</label>
                    <input type="text" required
                    class="form-control" id="product_id"
                    v-model="currentProduct.id">
                  </div>
                  <div class="form-group">
                    <label for="product_title">產品名稱</label>
                    <input type="text" required
                    class="form-control"
                    id="product_title"
                    v-model="currentProduct.title">
                  </div>
                  <div class="form-group">
                    <label for="product_price">價格</label>
                    <input type="number" min="1" required
                    class="form-control" id="product_price"
                    v-model="currentProduct.price">
                  </div>
                  <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="product_is_new"
                    v-model="currentProduct.is_new">
                    <label class="form-check-label" for="product_is_new">使否標示為新產品</label>
                  </div>
                  <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="product_on_banner"
                    v-model="currentProduct.on_banner">
                    <label class="form-check-label" for="product_on_banner">使否在首頁輪播</label>
                  </div>
                  <hr>
                  <div class="form-row">
                    <div class="form-group col-4 col-md-3"
                    v-for="(item, index) in currentProduct.category"
                    :key="index">
                      <label>
                        <span class="pr-1">產品分類--{{index + 1}}</span>
                        <button class="btn btn-sm btn-secondary"
                        @click.prevent="delete_category(index)">
                        刪除
                        </button>
                      </label>
                      <input type="text" class="form-control" placeholder="描述標題"
                      v-model="item.chinese">
                      <input type="text" class="form-control" placeholder="描述內容"
                      v-model="item.english">
                    </div>
                    <button class="btn btn-success col-4 col-md-3 mt-3 mb-3"
                    @click.prevent="add_new_category">
                      新增產品分類
                    </button>
                  </div>
                  <div class="form-row">
                    <div class="p-1 col-4 col-md-3"
                    v-for="(item, index) in categoryMenu"
                    :key="index">
                      <button class="btn btn-secondary
                      col d-flex flex-column align-items-center"
                      @click.prevent="add_new_category(item)">
                        <span>{{item.chinese}}</span>
                        <span>{{item.english}}</span>
                      </button>
                    </div>
                  </div>
                  <hr>
                  <div class="form-row">
                    <div class="col-4 col-md-3 mb-2">
                      <div class="form-group"
                      v-if="currentProduct.images.main === ''">
                        <label for="mainImg">新增主要圖片</label>
                        <input type="file" class="form-control-file" id="mainImg"
                        accept="image/gif, image/jpeg, image/png"
                        @change='previewImg($event.target)'>
                        <img class="obj-cover image w-100 h-100 rounded mt-2"
                        src="" alt="" id='mainImgPreview'>
                      </div>
                      <div
                      v-if="currentProduct.images.main !== ''">
                        <button class="btn btn-secondary btn-sm mb-1"
                        @click.prevent="delete_img('main')">
                          刪除主要圖片
                        </button>
                        <img class="obj-cover image w-100 h-100 rounded"
                        :src="currentProduct.images.main"
                        @click="lightBoxindex = 0">
                      </div>
                    </div>
                    <div class="col-4 col-md-3 mb-2">
                      <div class="form-group"
                      v-if="currentProduct.images.banner === ''">
                        <label for="bannerImg">新增首頁圖片</label>
                        <input type="file" class="form-control-file" id="bannerImg"
                        accept="image/gif, image/jpeg, image/png"
                        @change='previewImg($event.target)'>
                        <img src="" alt="" id='bannerImgPreview'
                        class="obj-cover image w-100 h-100 rounded mt-2">
                      </div>
                      <div
                      v-if="currentProduct.images.banner !== ''">
                        <button class="btn btn-secondary btn-sm mb-1"
                        @click.prevent="delete_img('banner')">
                          刪除首頁圖片
                        </button>
                        <img class="obj-cover image w-100 h-100 rounded"
                        :src="currentProduct.images.banner"
                        @click="lightBoxindex = 1">
                      </div>
                    </div>
                    <div class="col-4 col-md-3 mb-2"
                    v-for="(item, i) in currentProduct.images.others"
                    :key="i">
                      <div class="form-group"
                      v-if="item === ''">
                        <label :for="`img${i}`">其他圖片 {{i + 1}}</label>
                        <input type="file" class="form-control-file" :id="`img${i}`"
                        accept="image/gif, image/jpeg, image/png"
                        @change='previewImg($event.target)'>
                        <img src="" alt="" :id='`img${i}Preview`'
                        class="obj-cover image w-100 h-100 rounded mt-2">
                      </div>
                      <div
                      v-if="item !== ''">
                        <button class="btn btn-secondary btn-sm mb-1"
                        @click.prevent="delete_img(i)">
                          刪除
                        </button>
                        <img class="obj-cover image w-100 h-100 rounded"
                        :src="item"
                        @click="lightBoxindex = i">
                      </div>
                    </div>
                    <button class="btn btn-success col-4 col-md-3 mt-3 mb-3"
                    @click.prevent="add_new_image">
                      新增其他圖片
                    </button>
                    <vue-gallery-slideshow
                      :images="images"
                      :index="lightBoxindex"
                      @close="lightBoxindex = null">
                    </vue-gallery-slideshow>
                  </div>
                  <hr>
                  <div class="form-row">
                    <div class="form-group col-4 col-md-3"
                    v-for="(item, index) in currentProduct.description"
                    :key="index">
                      <label>
                        <span class="pr-1">產品描述--{{index + 1}}</span>
                        <button class="btn btn-sm btn-secondary"
                        @click.prevent="delete_description(index)">
                        刪除
                        </button>
                      </label>
                      <input type="text" class="form-control" placeholder="描述標題"
                      v-model="item.title">
                      <textarea class="form-control" rows="3"
                      v-model="item.text"
                      ></textarea>
                    </div>
                    <button class="btn btn-success col-4 col-md-3 mt-3 mb-3"
                    @click.prevent="add_new_description">
                      新增產品描述
                    </button>
                  </div>
                  <hr>
                  <div class="form-group">
                    <label for="product_content">產品內容</label>
                    <textarea class="form-control" id="product_content" rows="10"
                    v-model="currentProduct.content"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
  components: { VueGallerySlideshow },
  computed: {
    products() {
      let arr = [];
      this.$bus.$on('son_get_data', (data) => {
        arr = data.products;
      });
      this.$bus.$emit('son_call_data');
      return arr;
    },
    categories() {
      let arr = [];
      const allCategoryStr = this.products
        .map((item) => item.category)
        .flat(1)
        .map((item) => JSON.stringify(item));
      const noRepeatArr = [...new Set(allCategoryStr)]
        .map((item) => JSON.parse(item));
      arr = noRepeatArr;
      return arr;
    },
    images() {
      let arr = [];
      const imageObj = this.currentProduct.images;
      const imageArr = Object.values(imageObj).flat(2);
      arr = imageArr;
      return arr;
    },
  },
  data() {
    return {
      productListShown: true,
      productDetailShown: false,
      creatingNewProduct: true,
      currentProduct: {
        title: '',
        id: '',
        price: 1,
        is_new: false,
        on_banner: false,
        category: [
        ],
        images: {
          main: '',
          banner: '',
          others: [],
        },
        content: '',
        description: [
        ],
      },
      categoryMenu: [],
      lightBoxindex: null,
    };
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    toggle_productList(boolean) {
      this.productListShown = boolean;
    },
    toggle_productDetail(boolean) {
      this.productDetailShown = boolean;
    },
    submit_form(product) {
      const checkImgs = () => {
        let boolean = false;
        if (this.currentProduct.images.main === '') {
          this.$bus.$emit('show_toast', 'warning', '不可以沒有主要圖片');
        } else if (this.currentProduct.images.banner === '') {
          this.$bus.$emit('show_toast', 'warning', '不可以沒有首頁圖片');
        } else {
          boolean = true;
        }
        return boolean;
      };
      if (checkImgs()) {
        if (this.creatingNewProduct) {
          // 新增產品
          this.$bus.$emit('add_new_product', product);
        } else {
          // 儲存變更
          this.$bus.$emit('edit_product', product);
        }
      }
    },
    delete_product(product) {
      const confirm = window.confirm('確定要刪除嗎?');
      if (confirm) {
        this.$bus.$emit('delete_product', product);
        this.start_creating_newProduct();
      }
    },
    add_new_description() {
      const newD = {
        title: '',
        text: '',
      };
      this.currentProduct.description.push(newD);
    },
    delete_description(index) {
      this.currentProduct.description.splice(index, 1);
    },
    reset_categoryMenu() {
      this.categoryMenu = this.categories
        .filter((item) => this.currentProduct.category
          .find((item2) => JSON.stringify(item2) === JSON.stringify(item)) === undefined);
    },
    add_new_category(newC = { chinese: '', english: '' }) {
      this.currentProduct.category.push(newC);
      this.reset_categoryMenu();
    },
    delete_category(index) {
      this.currentProduct.category.splice(index, 1);
      this.reset_categoryMenu();
    },
    add_new_image() {
      const newStr = '';
      this.currentProduct.images.others.push(newStr);
    },
    delete_img(img) {
      switch (img) {
        case 'main':
          this.currentProduct.images.main = '';
          break;
        case 'banner':
          this.currentProduct.images.banner = '';
          break;
        default:
          this.currentProduct.images.others[img] = '';
          break;
      }
    },
    start_creating_newProduct() {
      this.currentProduct = {
        title: '',
        id: '',
        price: 1,
        is_new: false,
        on_banner: false,
        category: [
        ],
        images: {
          main: '',
          banner: '',
          others: [],
        },
        content: '',
        description: [
        ],
      };
      this.creatingNewProduct = true;
      this.rwdSet();
      this.reset_categoryMenu();
    },
    start_editing(id) {
      const thisP = this.products.find((item) => item.id === id);
      this.currentProduct = JSON.parse(JSON.stringify(thisP));
      this.creatingNewProduct = false;
      this.rwdSet();
      this.reset_categoryMenu();
    },
    rwdSet() {
      const w = $(window).width();
      if (w >= 768) {
        this.toggle_productList(true);
        this.toggle_productDetail(true);
      } else {
        this.toggle_productList(false);
        this.toggle_productDetail(true);
      }
    },
    previewImg(input) {
      const inputId = input.id;
      const target = document.getElementById(`${inputId}Preview`);
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = (e) => {
          target.setAttribute('src', e.target.result);
        };
      } else {
        target.setAttribute('src', '');
      }
    },
  },
  created() {
    this.start_creating_newProduct();
  },
  mounted() {
    this.rwdSet();
    $(window).resize(() => {
      this.rwdSet();
    });
  },
};
</script>
